import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tracker } from "@openreplay/tracker";

import { DATA_EXPLORER_EVENTS } from "@helpers/events";

import { getFileDownloadUrl, getFolderDownloadUrl } from "../helpers/api";
import { useExtractTarHelp } from "./ExtractTarDialog";

const DownloadArea = styled("div")({
  marginLeft: "auto",
});

function downloadLabel(path: string) {
  const name = path.split("/").pop();
  return name ? `Download "${name}"` : "Download all";
}

/**
 * "pending" covers the moment after navigating, before the listing says
 * whether the path is a file or a folder.
 */
export type SelectionKind = "file" | "folder" | "pending";

/**
 * Downloads the previewed file, or the open folder as a .tar. While pending
 * it shows the same label disabled, so it doesn't flip between the two.
 */
const DownloadButton = (props: {
  dataId: string;
  path: string;
  kind: SelectionKind;
}) => {
  const { dataId, path, kind } = props;
  const extractHelp = useExtractTarHelp();
  const link =
    kind === "file"
      ? {
          href: getFileDownloadUrl(dataId, path),
          onClick: () =>
            tracker.event(
              DATA_EXPLORER_EVENTS.DETAIL_FILE_DOWNLOAD_CLICKED,
              dataId,
            ),
        }
      : kind === "folder"
        ? {
            href: getFolderDownloadUrl(dataId, path),
            onClick: () => {
              tracker.event(
                DATA_EXPLORER_EVENTS.DETAIL_FOLDER_DOWNLOAD_CLICKED,
                { dataId, isRoot: !path },
              );
              extractHelp.show();
            },
          }
        : undefined;
  return (
    <DownloadArea>
      <Button
        variant="outlined"
        startIcon={<Download />}
        disabled={!link}
        href={link?.href}
        onClick={link?.onClick}
      >
        {downloadLabel(path)}
      </Button>
      {extractHelp.dialog}
    </DownloadArea>
  );
};

export default DownloadButton;
